import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BusinessUnitModel} from '../models/businessUnit';
import {BaseService} from './base.service';
import {map} from 'rxjs/operators';

export interface UsineReferencesModel {
  references: string[];
  detachees: string[];
}

@Injectable({providedIn: 'root'})
export class BusinessUnitService extends BaseService {

  private readonly baseUrl = `${environment.apiPath}business-unit/`;
  private readonly baseUrlV2 = `${environment.apiPathV2}business-unit/`;

  getListBusinessUnit(): Observable<Array<BusinessUnitModel>> {
    return this.get(this.baseUrl + 'list/').pipe(
      map(item => {
        return item as Array<BusinessUnitModel>;
      }),
    );
  }

  updateBusinessUnit(usine): Observable<boolean> {
    return this.post(this.baseUrl + 'update', usine).pipe(
      map(() => {
        return true;
      }),
    );
  }

  insertBusinessUnit(usine): Observable<number> {
    return this.post(this.baseUrl + 'insert', usine).pipe(
      map(item => {
        return item['inserted_id'];
      }),
    )
  }

  getReferencesBusinessUnit(idUsine: number): Observable<UsineReferencesModel> {
    return this.get(`${this.baseUrl}${idUsine}/references`).pipe(
      map(item => item as UsineReferencesModel),
    );
  }

  deleteBusinessUnit(idUsine: number): Observable<unknown> {
    return this.http.delete(`${this.baseUrl}${idUsine}`, {
      headers: this.createAuthorizationHeader(),
    });
  }

  getAllBusinessUnitActive(): Observable<BusinessUnitModel[]> {
    return this.http.get<BusinessUnitModel[]>(this.baseUrlV2 + 'active');
  }

  getBusinessUnitByFichePreparation(idFichePreparation: number): Observable<BusinessUnitModel> {
    return this.http.get<BusinessUnitModel>(`${this.baseUrlV2}fiche-preparation/${idFichePreparation}`);
  }
}
